import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitialstates_coral';
import './CustomeSelect_Coral.css';

const CustomeSelect_Coral = (props) => {
  const { IND, filterdata, columnfilters } = props;
  const [loadedOption, setLoadedOption] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    const responce = [];
    if (res_result.length != 0) {
      res_result.map((d) => {
        responce.push({ "id": d.key.column, "value": d.key.column, "label": d.key.column.toString() })
      })
    }
    setLoadedOption((preState) => [{ label: "All", value: "*" }, ...responce]);
    setSelectedOptions((preState) => [{ label: "All", value: "*" }, ...responce]);
  }

  useEffect(() => {
    if (props.changedColumn != IND) {
      fetchData({ url: API_URL_MAIN + "coral_drive_analysis/drivefilter", body: { IND, filterdata, columnfilters } }, appyData)
    }
  }, [props])

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `All`;
    } else {
      return `${value.length} selected`;
    }
  }

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options);
      props.updateFilter(this.options, IND);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([]);
      props.updateFilter([], IND);
    } else if (event.action === "deselect-option") {
      const re = value.filter((o) => o.value !== "*");
      this.setState(re);
      props.updateFilter(re, IND);
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
      props.updateFilter(this.options, IND);
    } else {
      this.setState(value);
      props.updateFilter(value, IND);
    }
  }

  return (
    <>
      <span className="select_col_title">{props.lable}</span>
      <ReactMultiSelectCheckboxes className="react-select-container" classNamePrefix="react-select" style={{ dropdownButton: { width: "100%" } }}
        options={[...loadedOption]}
        placeholderButtonLabel={props.lable}
        getDropdownButtonLabel={getDropdownButtonLabel}
        value={selectedOptions}
        onChange={onChange}
        setState={setSelectedOptions}
      />
    </>
  )
}

export default CustomeSelect_Coral;